import enviarPeticion from "./EnviarPeticion";
import { INTELISIS } from "./ApiRoutes";

const ObtenerToken = async () => {
    const data = {
        usuario: "AltaCteCol",
        contrasena: "01£ebh1HO?vvx6v"
    }

    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
    };

    const res = await enviarPeticion(config, INTELISIS.Login);
    return res;
}

export default (ObtenerToken)